import { put } from 'redux-saga/effects';
import { setQueryParam } from 'functions/urlHelpers';

function* setFilter({ fetchAction, queryParam }, { payload: value }) {
  setQueryParam(queryParam, value);
  yield put(fetchAction());
}

export default setFilter;
